module.exports = __webpack_public_path__ + "img/cancroEuropeu-capa.35799c46.webp";